import LoginView from '@auth/views/LoginView'
import * as React from '@integrations/react'
import { configuration, paths } from 'mmfintech-backend-api'
import type { RouteDefinition } from 'mmfintech-backend-api/types'

const LazyTransactionFinalStatus = React.lazy(() => import('@transactions/views/TransactionFinalStatusView'))

// prettier-ignore
export const nonProtectedRoutes: RouteDefinition[] = [
  { path: paths.login(), component: LoginView },
  { path: paths.signUp(), component: React.lazy(() => import('@auth/views/SignupView')) },
  {
    path: paths.signUpViaInviteLink(':referralCode'),
    check: paths.signUpViaInviteLink('*'),
    component: React.lazy(() => import('@auth/views/SignupView'))
  },
  {
    path: paths.invite(':link'),
    check: paths.invite('*'),
    component: React.lazy(() => import('@auth/views/InviteHandler'))
  },
  { path: paths.checkEmail(), component: React.lazy(() => import('@auth/views/VerifyEmailMessageView')) },
  { path: paths.passwordReset(), component: React.lazy(() => import('@auth/views/ResetPasswordMessageView')) },
  { path: paths.forgotPassword(), component: React.lazy(() => import('@auth/views/ForgotPasswordView')) },
  { path: paths.handleEmailVerify(), component: React.lazy(() => import('@auth/views/VerifyEmailView')) },
  { path: paths.changePasswordEmail(), component: React.lazy(() => import('@auth/views/ForgotPasswordMessageView')) },
  { path: paths.handlePasswordReset(), component: React.lazy(() => import('@auth/views/ResetPasswordView')) },
  { path: paths.handleInvitationVerify(), component: React.lazy(() => import('@auth/views/VerifyEmailView')) },
  { path: paths.handlePasswordResetInvited(), component: React.lazy(() => import('@auth/views/SetPasswordView')) },

  {
    path: paths.banking.boleto.fail(),
    component: LazyTransactionFinalStatus,
    params: { isSuccess: false, method: 'boleto' }
  },
  {
    path: paths.banking.boleto.success(),
    component: LazyTransactionFinalStatus,
    params: { isSuccess: true, method: 'boleto' }
  },
  {
    path: paths.banking.instantBankTransfer.fail(),
    component: LazyTransactionFinalStatus,
    params: { isSuccess: false, method: 'direct_instant_bank_transfer' }
  },
  {
    path: paths.banking.instantBankTransfer.success(),
    component: LazyTransactionFinalStatus,
    params: { isSuccess: true, method: 'direct_instant_bank_transfer' }
  },
  {
    path: paths.banking.finalStatus.fail(':method'),
    component: LazyTransactionFinalStatus,
    params: { isSuccess: false }
  },
  {
    path: paths.banking.finalStatus.success(':method'),
    component: LazyTransactionFinalStatus,
    params: { isSuccess: true }
  },

  ...(configuration.isLocal()
    ? [{ path: '/test-styles', component: React.lazy(() => import('../modules/testStyles/WebComponentsTest')) }]
    : [])
]
